export default __webpack_public_path__ + "static/media/alejandro-loguercio-smiling.92cf73be.jpg";